import Guestbook from "@/components/wedding/Guestbook";

export default function GuestbookPage() {
  return (
    <div data-testid="guestbook-page">
      <Guestbook />
    </div>
  );
}
